
import axios from "axios";
import * as constants from "../../Constatnts";


export function  saveSalesChannel(key, salesChannel){
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/setup/saleschannels/${key}`,
          salesChannel,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/setup/saleschannels`,
          salesChannel,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.salesChannel.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function deleteSalesChannel(key){
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.delete(
        `${constants.API_URL}/setup/saleschannels/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
        return true
      }
      else{
        return false
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

